import { render, staticRenderFns } from "./NotificationItemParts.vue?vue&type=template&id=54d46e50&scoped=true"
import script from "./NotificationItemParts.vue?vue&type=script&lang=ts"
export * from "./NotificationItemParts.vue?vue&type=script&lang=ts"
import style0 from "./NotificationItemParts.vue?vue&type=style&index=0&id=54d46e50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d46e50",
  null
  
)

export default component.exports